import { FC } from 'react';
import {Modal} from './Modal'

import {useIntl} from 'react-intl'

import { Link } from 'react-router-dom';
import { useAuth } from '../context/auth';
import { useLang } from '../../_metronic/i18n/Metronici18n';
import { UserType } from '../models';

interface Props {
  show: boolean
  handleClose: () => void
}

const isFirstTime = () => localStorage.getItem('firstTime') === null

const notFirstTime = () => localStorage.setItem('firstTime', 'false')

const AboutModal: FC<Props> = ({ show, handleClose }) => {
  
  const intl = useIntl()

  const {currentUser} = useAuth()
  const selectedLang = useLang()

  return <Modal 
          show={show} 
          handleClose={handleClose} 
          dialogClassName="modal-dialog modal-dialog-centered w-lg-500px"
          modalBodyClassName="overflow-y-auto mh-500px">
      <div className="d-flex flex-lg-row flex-column flex-center gap-10">
        <div>
          <img src="/images/logos/full-logo.svg" className={`${currentUser && !currentUser.email ? 'w-100px' : 'w-70px'} theme-light-show`} alt=""/>
          <img src="/images/logos/white-full-logo.svg" className={`${currentUser && !currentUser.email ? 'w-100px' : 'w-70px'} theme-dark-show`} alt=""/>
        </div>
        <div className="fs-5 text-center text-lg-start">
          <h4>{intl.formatMessage({ id: "general.fanar_chat.title" })}</h4>
          {intl.formatMessage({ id: "general.fanar_chat.description" })} 
          { currentUser && !currentUser.email && 
          <div className="d-flex flex-row mt-3 gap-2 flex-center flex-lg-start">
            <button
              className="btn btn-secondary"
              onClick={handleClose}
            >
              {intl.formatMessage({ id: "general.chat_with_fanar" })}
            </button>
            <Link className="btn btn-primary" to="/a/sign-in">
              {intl.formatMessage({id: 'user.sign_in'})}
            </Link>
          </div>
          }
          <div className="d-flex mt-5 fs-7 flex-row gap-5 flex-center flex-lg-start">
            <a href={`https://fanar.qa/${selectedLang}`} target="_blank">{intl.formatMessage({id: 'general.learn_more'})}</a>
            <a href="/terms-of-service" target="_blank">{intl.formatMessage({id: 'general.terms'})}</a>
            <a href="/privacy-policy" target="_blank">{intl.formatMessage({id: 'general.privacy'})}</a>
          </div>
        </div>
      </div>
       
    </Modal>
  }
  
  export {AboutModal, notFirstTime, isFirstTime}